// src/components/PrivateRoute.js
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem("token"); // You can replace this with any auth logic
  return token ? children : <Navigate to="/login" />;
}
